/**
 * Mode-aware wrapper for sessions route.
 * Dispatches to in-person or remote page based on {@link useMode}.
 */

import { useMode } from '@/contexts/ModeContext';
import { SessionsManagementPage as SessionsInPersonManagementPage } from '@/components/pages/management-pages/inperson/SessionsManagementPage';
import { SessionsManagementPage as SessionsRemoteManagementPage } from '@/components/pages/management-pages/remote/SessionsManagementPage';

/** Mode-aware wrapper that mounts in-person or remote sessions. */
export function SessionsRouteDispatcher() {
  const { mode } = useMode();

  if (mode === 'remote') {
    return <SessionsRemoteManagementPage />;
  }

  return <SessionsInPersonManagementPage />;
}
